import { Injectable } from '@angular/core';

interface StorageCache {
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class TemporaryStorageService {
  private readonly cache: StorageCache;
  private readonly isSessionStorageAvailable: boolean;

  constructor() {
    this.cache = Object.create(null);
    this.isSessionStorageAvailable = !!sessionStorage;
  }

  set(key: string, objectToCache: any): void {
    try {
      const serializedCache = JSON.stringify(objectToCache);
      if (this.isSessionStorageAvailable) {
        sessionStorage.setItem(key, serializedCache);
      } else {
        this.cache[key] = serializedCache;
      }
    } catch (error) {
      console.warn('Unable to write to SessionStorage API.');
      console.error(error);
    }
  }

  get(key: string): any {
    try {
      let serializedCache = null;
      if (this.isSessionStorageAvailable) {
        serializedCache = sessionStorage.getItem(key);
      } else {
        serializedCache = this.cache[key];
      }

      if (serializedCache) {
        return JSON.parse(serializedCache);
      }
    } catch (error) {
      console.warn('Unable to read from SessionStorage API.');
      console.error(error);
    }
  }
}
